import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    payInfo:{},  //预下单查询返回信息
    accList:{},   //卡列表
    smsType:"",   //支付是否需要短信验证
    successUrl:"",  //回调酷屏地址
    orderNo:"",
    routerFlag:false,  //是否跳转到协议页面
    agreeFlag:false,  //是否同意协议
  },
  mutations: {
    setPayInfo:(state, payInfo) => {
      state.payInfo = payInfo
    },
    setAccList:(state,accList) => {
      state.accList = accList
    },
    setSmsType:(state, smsType) => {
      state.smsType = smsType
    },
    setSuccessUrl:(state,successUrl) => {
      state.successUrl = successUrl
    }
  },
  actions: {

  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js